import { Container } from "react-bootstrap";
import About from "./About";
import Experience from "./Experience";
import Skills from "./Skills";
import Education from "./Education";
import Certifications from "./Certifications";
import Hobbies from "./Hobbies";
import Languages from "./Languages";
import CvHeader from "./CvHeader";
import { useRef } from "react";
import References from "./References";


const DesktopViewCV = () => {

    const ref = useRef(); // Ref for the content to be converted to PDF

    return (

        <div className="desktop-view-cv">

            <CvHeader />

            <Container className="cv-layout py-4" ref={ref}>

                <aside className="cv-sidebar">
                    <Skills />
                    <Languages />
                    <Hobbies />
                </aside>

                <main className="cv-main">
                    <About />
                    <Experience />
                    <Education />
                    <Certifications />
                    <References />
                </main>

            </Container>

        </div>

    )

}

export default DesktopViewCV;